import React, { useContext } from 'react';

export const SECTION_MAP = {
  users: 'users',
  structure: 'structure',
  functional: 'functional',
};

const initial = {
  [SECTION_MAP.users]: false,
  [SECTION_MAP.structure]: false,
  [SECTION_MAP.functional]: false,
};

const MenuContext = React.createContext();

export const MenuProvider = ({ children }) => {
  const [open, setState] = React.useState(initial);

  const onToggle = (section) => {
    if (open[section]) {
      setState({ ...open, [section]: false });
    } else {
      setState({ ...open, [section]: true });
    }
  };

  return (
    <MenuContext.Provider value={[open, onToggle]}>
      {children}
    </MenuContext.Provider>
  );
};

export function useMenuState() {
  return useContext(MenuContext);
}
